/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2015, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../ModeButton',
	'../../../api/DashboardAPI',
	'../../../app/nls/StringResources'
], function(BaseClass, DashboardAPI, StringResources) {

	class ActionHandler extends BaseClass {
		onPress(context) {
			const dashboard = context.glassContext.appController.getCurrentContentView().getDashboardApi();
			if (dashboard.getMode() !== DashboardAPI.MODES.VIEW) {
				dashboard.getFeature('DashboardState').setAuthoring(false);
			} else {
				return this._checkCapabilitiesOfSources(dashboard)
					.then((hasCapability) => {
						if (hasCapability) {
							dashboard.getFeature('DashboardState').setAuthoring(true);
						} else {
							this._unpressEditButton(context.glassContext.appController);
							dashboard.showToast(StringResources.get('noCapabilityForEdit'), {
								type: 'error',
								preventDuplicates: true
							});
						}
					})
					.catch((error) => {
						this._unpressEditButton(context.glassContext.appController);
						dashboard.getFeature('Logger').error('Fail to check capabilities in Edit mode', error);
					});
			}
		}

		_unpressEditButton(appController) {
			const plugin = appController.findPlugin('com.ibm.bi.dashboard.mode');
			if (plugin && plugin.button && plugin.button.isPressed()) {
				plugin.button.setUnpressed();
			}
		}

		_checkCapabilitiesOfSources(dashboard) {
			const capabilitiesFeature = dashboard.getFeature('Capabilities');
			if (!capabilitiesFeature) {
				return Promise.resolve(true);
			}
			const sources = dashboard.getFeature('DataSources').getDataSourceList();
			const sourceInfos = [];
			for (let i = 0; i < sources.length; i++) {
				sourceInfos.push({
					assetId: sources[i].getAssetId(),
					type: sources[i].getType()
				});
			}
			return capabilitiesFeature.hasCapability(sourceInfos);
		}
	}

	return ActionHandler;
});
